<head>
  <meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<template>
  <div class="Evaluation-modal-overlay">
    <div class="Evaluation-modal" @click.stop>
      <h3 style="font-size: 1.5rem; margin-bottom: 10px;">Task Assessment for Task (ID: {{  this.selectedTaskAssessmentNew.task_id }})</h3>
      <table class="assessment-table">
        <thead>
          <tr>
            <th style="width: 10%;">Task No</th>
            <th>Description</th>
            <th style="width: 20%;">Attempt 1</th>
            <th style="width: 20%;">Attempt 2</th>
            <th style="width: 20%;">Attempt 3</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ this.selectedTaskAssessmentNew.task_no }}</td>
            <td>{{ this.selectedTaskAssessmentNew.description }}</td>
            <td style="text-align: center;">
              <button class="assess-button" :class="{
                'pass-button': this.selectedTaskAssessmentNew.assessments?.[0]?.result === 'pass' && this.selectedTaskAssessmentNew.assessments[0]?.is_submitted >= 3,
                'fail-button': this.selectedTaskAssessmentNew.assessments?.[0]?.result === 'fail' && this.selectedTaskAssessmentNew.assessments[0]?.is_submitted >= 3,
                'in-progress-button': this.selectedTaskAssessmentNew.assessments?.[0]?.is_submitted === 1 || this.selectedTaskAssessmentNew.assessments?.[0]?.is_submitted === 2,
              }" @click="openTaskAssessmentModal(1)" :disabled="this.selectedTaskAssessmentNew.is_selected === 1 && (!this.selectedTaskAssessmentNew.assessments[0] || this.selectedTaskAssessmentNew.assessments?.[0]?.is_submitted === 1)">
                <template
                  v-if="this.selectedTaskAssessmentNew.assessments?.[0]?.result === 'pass' && this.selectedTaskAssessmentNew.assessments[0]?.is_submitted >= 3">
                  Passed
                </template>
                <template
                  v-else-if="this.selectedTaskAssessmentNew.assessments?.[0]?.result === 'fail' && this.selectedTaskAssessmentNew.assessments[0]?.is_submitted >= 3">
                  Failed
                </template>
                <template
                  v-else-if="this.selectedTaskAssessmentNew.assessments?.[0]?.result && this.selectedTaskAssessmentNew.assessments[0]?.is_submitted === 2">
                  Signature Required
                </template>
                <template v-else-if="this.selectedTaskAssessmentNew.assessments?.[0]?.is_submitted === 1">
                  In Progress
                </template>
                <template v-else>
                  Awaiting Assessment
                </template>
              </button>
            </td>
            <td style="text-align: center;">
              <button class="assess-button" :class="{
                'pass-button': this.selectedTaskAssessmentNew.assessments?.[1]?.result === 'pass' && this.selectedTaskAssessmentNew.assessments[1]?.is_submitted >= 3,
                'fail-button': this.selectedTaskAssessmentNew.assessments?.[1]?.result === 'fail' && this.selectedTaskAssessmentNew.assessments[1]?.is_submitted >= 3,
                'in-progress-button': this.selectedTaskAssessmentNew.assessments?.[1]?.is_submitted === 1 || this.selectedTaskAssessmentNew.assessments?.[1]?.is_submitted === 2,
              }"
                v-if="this.selectedTaskAssessmentNew.assessments?.[0]?.result === 'fail' && this.selectedTaskAssessmentNew.assessments[0]?.is_submitted >= 3"
                @click="openTaskAssessmentModal(2)">
                <template
                  v-if="this.selectedTaskAssessmentNew.assessments?.[1]?.result === 'pass' && this.selectedTaskAssessmentNew.assessments[1]?.is_submitted >= 3">
                  Passed
                </template>
                <template
                  v-else-if="this.selectedTaskAssessmentNew.assessments?.[1]?.result === 'fail' && this.selectedTaskAssessmentNew.assessments[1]?.is_submitted >= 3">
                  Failed
                </template>
                <template
                  v-else-if="this.selectedTaskAssessmentNew.assessments?.[1]?.result && this.selectedTaskAssessmentNew.assessments[1]?.is_submitted === 2">
                  Signature Required
                </template>
                <template v-else-if="this.selectedTaskAssessmentNew.assessments?.[1]?.is_submitted === 1">
                  In Progress
                </template>
                <template v-else>
                  Awaiting Assessment
                </template>
              </button>
            </td>
            <td style="text-align: center;">
              <button class="assess-button" :class="{
                'pass-button': this.selectedTaskAssessmentNew.assessments?.[2]?.result === 'pass' && this.selectedTaskAssessmentNew.assessments[2]?.is_submitted >= 3,
                'fail-button': this.selectedTaskAssessmentNew.assessments?.[2]?.result === 'fail' && this.selectedTaskAssessmentNew.assessments[2]?.is_submitted >= 3,
                'in-progress-button': this.selectedTaskAssessmentNew.assessments?.[2]?.is_submitted === 1 || this.selectedTaskAssessmentNew.assessments?.[2]?.is_submitted === 2,
              }"
                v-if="this.selectedTaskAssessmentNew.assessments?.[1]?.result === 'fail' && this.selectedTaskAssessmentNew.assessments[1]?.is_submitted >= 3"
                @click="openTaskAssessmentModal(3)">
                <template
                  v-if="this.selectedTaskAssessmentNew.assessments?.[2]?.result === 'pass' && this.selectedTaskAssessmentNew.assessments[2]?.is_submitted >= 3">
                  Passed
                </template>
                <template
                  v-else-if="this.selectedTaskAssessmentNew.assessments?.[2]?.result === 'fail' && this.selectedTaskAssessmentNew.assessments[2]?.is_submitted >= 3">
                  Failed
                </template>
                <template
                  v-else-if="this.selectedTaskAssessmentNew.assessments?.[2]?.result && this.selectedTaskAssessmentNew.assessments[2]?.is_submitted === 2">
                  Signature Required
                </template>
                <template v-else-if="this.selectedTaskAssessmentNew.assessments?.[2]?.is_submitted === 1">
                  In Progress
                </template>
                <template v-else>
                  Awaiting Assessment
                </template>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="button-container">
        <button class="ins-close-button" @click="close()">Close</button>
      </div>
      <task-assessment-modal v-if="showTaskAssessmentModal" :trainee="selectedTrainee" :tasks-count="MTCount"
        :completed-tasks="completedMTCount || 0" :taskAssessmentId="taskAssessmentId" :logbook-id="logbookId"
        :fetched-data="fetchedTaskAssessmentData" :attemptNo="attemptNo" :selectedTask="selectedTaskAssessment"
        @close="closeTaskAssessmentModal"></task-assessment-modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import TaskAssessmentModal from '@/components/Trainee/TraineeTaskAssessmentModal.vue';


export default {
  name: 'TaskAttemptModal',
  components: {
    TaskAssessmentModal,
  },
  props: {
    logbookId: {
      type: Number,
      required: true,
    },
    trainee: {
      type: Object,
      required: true,
    },
    selectedTaskAssessment: {
      type: Object,
      required: true,
    },
    assessmentMergedTasks: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      logbookEntry: {},
      showTaskAssessmentModal: false,
      fetchedTaskAssessmentData: null,
      MTCount: '',
      completedMTCount: '',
      task_assessments: [],
      attemptNo: '',
      selectedTask: '',
      selectedTaskAssessmentNew: [],
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    getRandomTask() {
      const filteredTasks = this.mergedTasks.filter(task => task.task !== 'LOC');
      const randomIndex = Math.floor(Math.random() * filteredTasks.length);
      return filteredTasks[randomIndex];
    },
    formatDate(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    fetchTraineeTaskAssessment() {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      const logbookId = this.logbookId;
      const taskId = this.selectedTaskAssessmentNew.task_id
      console.log('this.attemptNo');
      console.log(this.attemptNo);

      axios.get(`/api/task_assessments/${logbookId}/${taskId}/${this.attemptNo}`, { headers })
        .then(response => {
          const task_assessment = response.data;
          console.log('task_assessment');
          console.log(task_assessment);
          if (task_assessment) {
            this.taskAssessmentId = task_assessment.id;
            console.log('this.taskAssessmentId');
            console.log(this.taskAssessmentId);
            this.fetchedTaskAssessmentData = task_assessment;
          }
        })
        .catch(error => {
          console.error('There was an error fetching the task assessment:', error);
        });
    },
    openTaskAssessmentModal(attemptNo) {
      this.fetchedTaskAssessmentData = null;
      this.selectedTrainee = this.trainee;
      this.attemptNo = attemptNo; // Set the attempt number
      this.tasksCompleted = this.completedMTCount || 0;
      this.fetchTraineeTaskAssessment();
      this.showTaskAssessmentModal = true;
    },
    closeTaskAssessmentModal() {
      this.showTaskAssessmentModal = false;
      this.fetchTaskAssessmentData();
    },
    fetchTaskAssessmentData() {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      const logbookId = parseInt(this.logbookId);
      const taskId = this.selectedTaskAssessmentNew.task_id;

      axios.get(`/api/task_assessments/logbooks/${logbookId}/tasks/${taskId}`, { headers })
        .then(response => {
          this.task_assessments = response.data;
          console.log('assessments', this.task_assessments);
          this.selectedTaskAssessmentNew.assessments = this.task_assessments;
          console.log('selecteTaskassessments', this.selectedTaskAssessmentNew);
        });
    },
  },
  mounted() {
    console.log(this.trainee);
    console.log('assessment', this.selectedTaskAssessment);
    this.selectedTaskAssessmentNew = this.selectedTaskAssessment;

  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.modal-container {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 400px;
  width: 100%;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.modal-body {
  margin-bottom: 20px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
}

.confirm-button,
.cancel-button {
  padding: 10px 15px;
  margin-left: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.confirm-button {
  background-color: #28a745;
  color: white;
}

.cancel-button {
  background-color: #dc3545;
  color: white;
}

.trainee-table {
  width: 100%;
  border-collapse: collapse;
}

.trainee-table th,
.trainee-table td {
  padding: 10px;
  border: 1px solid #ddd;
}

.trainee-table th {
  background-color: #f4f4f4;
}

.Evaluation-modal-overlay {
  position: absolute;
  top: 0px;
  left: 0;
  background-color: rgba(97, 94, 94, 0.5);
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.Evaluation-modal {
  background-color: #ffffff;
  overflow-y: auto;
  /* Enables vertical scrolling if needed */
  margin-top: 2px;
  max-height: 85vh;
  max-width: min(60vw, 1400px);
  min-width: 80vw;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
  padding: 20px;
  z-index: 1002;
}

.modal-title {
  text-align: center;
  margin-bottom: 20px;
}

.assessment-table {
  width: 90%;
  border-collapse: collapse;
  align-items: center;
  margin: 0 auto;
}

.assessment-table th,
.assessment-table td {
  border: 1px solid #ddd;
  padding: 3px;
  text-align: left;
  font-size: 14px;
}

.assessment-table thead th {
  background-color: #f2f2f2;
  font-size: 15px;
}

.signature-section {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.signature-item label {
  width: 40%;
  display: block;
  margin-bottom: 5px;
}

.signature-placeholder,
.date-placeholder {
  border: 1px solid #ddd;
  padding: 5px;
  min-height: 30px;
  /* Adjust as needed */
}

.button-container {
  display: flex;
  justify-content: space-between;
  /* Aligns items to the right */
  align-items: center;
  margin-top: 20px;
  /* Adjust as needed */
}

.ins-save-button {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 20px;
  width: 100%;
  min-width: 90px;
  max-width: 100px;
}

.ins-submit-button {
  background-color: brown;
  border: 1px solid rgb(92, 23, 23);
  color: white;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 20px;
  min-width: 100px;
  max-width: 120px;
  margin-right: 5%;
  height: 35px;
}

.ins-close-button {
  background-color: #6c757d;
  border: 1px solid #4d5358;
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
  margin-left: 5%;
}

.ins-close-button:hover {
  background-color: #4d5358;
}

.ins-clear-button {
  background-color: #f0ac9c;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  margin-right: 0;
  width: 100%;
  min-width: 140px;
  max-width: 150px;
  border: 1px solid #c7715e;
}

.ins-save-button:disabled,
.ins-submit-button:disabled,
.ins-clear-button:disabled {
  background-color: rgb(216, 216, 216);
  cursor: not-allowed;
  color: grey
}

.ins-save-button:disabled:hover,
.ins-submit-button:disabled:hover,
.ins-clear-button:disabled:hover {
  background-color: rgb(216, 216, 216);
  color: grey
}

.ins-submit-button:hover {
  background-color: rgb(129, 33, 33);
}

.assessment-result {
  margin-left: 25%;
}

.task-performance {
  width: 50%;
  border-collapse: collapse;
  text-align: left;
  background-color: #f2f2f2;
  margin-left: 20px;
}

.task-performance th {
  /* Adjust the color to match your header background */
  font-weight: bold;
}


.task-performance input[type="text"] {
  width: 100%;
  border: none;
  padding: 4px;
  text-align: center;
  background-color: #f2f2f2;
}

.assessment-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
}


.signature-block {
  display: flex;
  flex-direction: column;
  margin-right: 70px;
}


.signature-table {
  width: 100%;
}

.signature-table td {
  padding: 4px;
  /* Adjust padding as needed */
  vertical-align: middle;
  /* Aligns content of <td> vertically in the middle */
}

.signature-table .signature {
  text-align: left;
  /* Aligns the text to the left */
}

.trainee-signature {
  text-align: left;
}

.signature-table input[type="text"],
.signature-table input[type="date"] {
  width: 100%;
  border: none;
  border-bottom: 1px solid black;
  border-radius: 0px;
  background-color: transparent;
  outline: none;
  height: 20px;
}

@media (max-width: 768px) {

  /* Adjust the max-width as needed for iPad or other tablet sizes */
  .Evaluation-modal {
    padding: 5px;
    font-size: 0.9em;
    /* Reduce font size */
  }

  /* Further adjustments for other elements */
}


#selectAllSatisfactory {
  margin-left: 5px;
  border: 1px solid rgb(206, 13, 13);
}

.signature-pad {
  border-bottom: 1px solid #000;
  border-radius: 5px;
}

.right {
  display: flex;
  justify-content: flex-end;
  margin-right: 5%;
}

/* Add this CSS to your stylesheet */
.signature-image-wrapper {
  position: relative;
  display: inline-block;
}

.signature-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  pointer-events: none;
  /* Prevents interaction with the overlay */
}

.disabled {
  opacity: 0.5;
  /* Optionally reduce opacity to indicate disabled state */
}

.assess-button {
  border: 1px solid #555c57;
  border-radius: 2px;
  background-color: #d6d6d6;
}

.assess-button:hover {
  background-color: rgb(180, 180, 180);
}

.assess-button:disabled:hover {
  cursor: not-allowed;
}

.pass-button {
  border: 1px solid #507458;
  border-radius: 2px;
  background-color: #b0e6bd;
  color: #075e1a;
}

.pass-button:hover {
  background-color: #82d896;
}

.fail-button {
  border: 1px solid #745050;
  border-radius: 2px;
  background-color: #e6b0b0;
  color: #7a0606;
}

.fail-button:hover {
  background-color: #d88282;
}

.in-progress-button {
  border: 1px solid #a06e36;
  border-radius: 2px;
  background-color: #e4d09c;
  color: #724400;
}

.in-progress-button:hover {
  background-color: #d8b382;
}

.missing-task {
  background-color: #fce2e4;
  /* Light red background for missing tasks */
}
</style>